// IE11, apparently Redmond didn't think Promises were important. For shame.
if (typeof window.Promise === 'undefined') {
  window.Promise = require('es6-promise').Promise;
}
import * as Env from '../constants/env';
import Store from '../data/store';
import UniteGalleryDefaults from '../contrib/UniteGalleryDefaults';
import GalleryTemplate from '../templates/Gallery.ejs';
import 'whatwg-fetch' // fetch() polyfill.

// Comments for show!
export class Gallery {
  constructor(obj = {}, UniteOpts = {}) {

    // Allow te plugin defaults to be overridden.
    this.UpdatedUniteDefaults = $.extend({}, UniteGalleryDefaults, UniteOpts);

    // Optional container the user can inject the viewer into.
    this.loadNode = obj.loadNode || 'MoxiGalleryViewer';

    // Set the listing id on the store
    Store.listingid = obj.listingid;

    if (typeof obj.fullScreenButton != "undefined") {
      this.fullScreenButton = obj.fullScreenButton;
    } else {
      this.fullScreenButton = true;
    }

    // Set Store data on the class.
    this.data = Store;

    // Init.
    this.init();
  }

  init() {

    // Fetch galley data.
    this.fetchGalleryData();
  }

  fetchGalleryData() {

    // Obj Reference
    const self = this;

    $.getJSON(`${Env.GALLERY_API}/get_gallery_data/${Store.listingid}`, (res) => {
      // Set the store data
      self.setStoreData(res, function() {
        // Render template, launch the gallery, set events.
        self.renderTemplate();
        self.launchGallery();
        self.setGalleryEvents();
      });
    });
  }

  setStoreData(res, callback) {

    // Tmp array & Loop Array to make sure everything is returned.
    // We compare these lengths before printing the viewer.
    // This is for the Vimeo ajax call mid-loop.
    let media_array = [];
    let loop_count_array = []

    // Loop over the results essentailly flattening the data starting with categories.
    res.data.result_list[0].gallery_categories.forEach((o, i) => {

      // Set the title on section name.
      var title = o.name;

      // Loop over all media in each category.
      o.gallery_medias.forEach((a, b) => {
        // Strip tags out of comments to be backwards compatible with photogallery authoring.
        if (a.description) a.description = a.description.replace(/<[^>]*>/ig, "");

        // Use set title for the alt attribute in the view.
        a.title = title;

        // Handle embedded data
        if (a.mime_type.indexOf('text/html') > -1) {
          var src = (/src\s*=\s*"(.+?)"/.exec(a.embedded) !== null) ? /src\s*=\s*"(.+?)"/.exec(a.embedded)[1] : '';
          a.videoId = src.split('/').pop();

          // Youtube is a special case as it works well within the plugin
          if (src.indexOf('youtube') > -1) {
            a.videoType = 'youtube';
            a.videoThumbSrc = `https://img.youtube.com/vi/${a.videoId}/0.jpg`;

            loop_count_array.push(1)

          } else if (src.indexOf('vimeo') > -1) {

            let video_id = src.split('/');
            video_id = video_id[video_id.length-1];
            video_id = video_id.split('?')[0];

            $.getJSON(`${Env.GALLERY_API}/get_vimeo_data/${video_id}`, { format: "json" }, function(data) {
              loop_count_array.push(1)
              if (typeof data.success !== 'undefined' && !data.success) {
                a.videoThumbSrc = 'https://moxi1.ssl.hwcdn.net/img-pr/i/3d234eb71d94aef25418cf4ccc074f7f2f438f7d/0_3_full.png';
              } else {
                a.videoThumbSrc = data.thumbnail_url;
              }
              a.videoType = 'custom';
            });

          // Handle other embed types.
          } else {
            loop_count_array.push(1)
            a.videoType = 'custom';
            a.videoThumbSrc = 'https://moxi1.ssl.hwcdn.net/img-pr/i/3d234eb71d94aef25418cf4ccc074f7f2f438f7d/0_3_full.png';
          }

          if (typeof a.special_thumb_url !== 'undefined' && a.special_thumb_url !== null) {
            a.videoThumbSrc = a.special_thumb_url.replace('thumb', 'full');
          }

        } else {
          loop_count_array.push(1)
        }

        // Append the new object to the array.
        media_array.push(a);
      });
    });

    // Set Data on Store
    let thumb_interval = setInterval(function() {
      if (parseInt(JSON.stringify(loop_count_array.length)) === parseInt(JSON.stringify(media_array.length))) {
        clearInterval(thumb_interval);
        Store.medium = media_array;
        callback();
      }
    }, 10);
  }

  renderTemplate() {
    // Render the template passing in the object data (store data accessable).
    document.getElementById(this.loadNode).innerHTML = GalleryTemplate(this);
  }

  launchGallery() {
    if (!this.fullScreenButton) {
      this.UpdatedUniteDefaults.slider_enable_fullscreen_button = false
      $('.ug-button-fullscreen').remove();
      $('.ug-button-play').css({
        'left': 'initial',
        'right': '20px'
      })
    }
    this.gallery = $("#MoxiGalleryContainer").unitegallery(this.UpdatedUniteDefaults);
  }

  setGalleryEvents() {
    const self = this;
    this.gallery.on("enter_fullscreen", function() {
      if (typeof detailSocket != "undefined" && typeof detailSocket.postMessage === "function") {
        detailSocket.postMessage("iframe_position_fixed");
      }
    });
    this.gallery.on("exit_fullscreen", function() {
      if (typeof detailSocket != "undefined" && typeof detailSocket.postMessage === "function") {
        detailSocket.postMessage("iframe_position_static");
      }
    });
    $(document).on('click', '#fullscreen-gallery-link', function() {
      self.gallery.enterFullscreen()
    });
  }

}



// WEBPACK FOOTER //
// ./src/components/Gallery.js